<template>
  <mdb-container class="limiter" style="padding-left: 0rem; padding-right: 0rem;">
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="login100-pic" v-tilt>
          <img :src="imgServer+'apps/myfrac/admin/assets/Ilustraciontarjeta@3x.png'" alt="IMG" />
        </div>

        <div class="login100-form">
          <div class="logo">
            <img alt="Logo MyFrac" :src="imgServer+'apps/myfrac/admin/assets/Logoazul@3x.png'" />
          </div>
          <br />
          <div class="alert alert-danger alert-dismissible" v-show="badCredentials">
            <button type="button" class="close" @click="badCredentialsStatus">×</button>
            <h4>
              <i class="icon fa fa-ban"></i> Error
            </h4>Usuario o contraseña incorrectos.
          </div>
          <div class="alert alert-danger alert-dismissible" v-show="badPermission">
            <button type="button" class="close" @click="badCredentialsStatus">×</button>
            <h4>
              <i class="icon fa fa-ban"></i> Error
            </h4>Asegurate que este usuario tenga permisos de administrador o integrador.
          </div>
          <div class="alert alert-danger alert-dismissible" v-show="disablePermission">
            <button type="button" class="close" @click="badCredentialsStatus">×</button>
            <h4>
              <i class="icon fa fa-ban"></i> Error
            </h4>No es posible iniciar sesión ya que su cuenta ha sido deshabilitada, para mayor información comunícate con tu administrador.
          </div>
          <div class="alert alert-danger alert-dismissible" v-show="NetworkError">
            <button type="button" class="close" @click="badCredentialsStatus">×</button>
            <h4>
              <i class="icon fa fa-ban"></i> Error
            </h4>No es posible iniciar sesión ya que hay un error de red.
          </div>

          <div
            class="form-group has-feedback wrap-input100"
            :class="{ 'has-error': hasErrorUsername }"
          >
            <input
              class="input100"
              type="email"
              name="email"
              placeholder="Correo electrónico"
              v-model="loginUser"
              @keyup="keymonitor"
            />
            <span class="symbol-input100Error" v-show="hasErrorUsername">
              <i class="fa fa-envelope" aria-hidden="true"></i>
            </span>
            <span class="symbol-input100" v-show="!hasErrorUsername">
              <i class="fa fa-envelope" aria-hidden="true"></i>
            </span>
            <span class="focus-input100"></span>
            <span class="help-block" style="color: #dd4b39;" v-show="hasErrorUsername">
              <strong>El campo es obligatorio.</strong>
            </span>
          </div>

          <div
            class="form-group has-feedback wrap-input100"
            :class="{ 'has-error': hasErrorPassword }"
          >
            <input
              class="input100"
              type="password"
              name="password"
              placeholder="Contraseña"
              v-model="loginPass"
              @keyup="keymonitor"
            />
            <span class="focus-input100"></span>
            <span class="symbol-input100" v-show="!hasErrorPassword">
              <i class="fa fa-lock" aria-hidden="true"></i>
            </span>
            <span class="symbol-input100Error" v-show="hasErrorPassword">
              <i class="fa fa-lock" aria-hidden="true"></i>
            </span>
            <span class="help-block" style="color: #dd4b39;" v-show="hasErrorPassword">
              <strong>El campo es obligatorio.</strong>
            </span>
          </div>

          <div class="container-login100-form-btn">
            <button type="submit" class="login100-form-btn" @click="login()">Iniciar Sesión</button>
          </div>

          <div class="text-center" style="padding-top: 12px;">
            <a class="txt2" href="/resetPassword">¿Olvidaste tu contraseña?</a>
          </div>
        </div>
      </div>
    </div>
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Servers from "../../server.js";
import { mapGetters, mapActions } from "vuex";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbInput,
  mdbBtn,
  mdbIcon,
  mdbView,
  mdbMask
} from "mdbvue";

export default {
  name: "LoginMain",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbInput,
    mdbBtn,
    mdbIcon,
    mdbView,
    mdbMask
  },
  data() {
    return {
      imgServer: Servers.serverImg,
      activePage: "Login",
      toggle: false,
      email: "",
      password: "",
      resetRoute: "/resetPassword",
      showErrorLogin: false,
      showErrorLogin2: false,
      whoami: [],
      serverWeb: Servers.serverWeb,
      isLoding: false,
      loginUser: "",
      loginPass: "",
      keepSession: false,
      variable: false,
      hasErrorUsername: false,
      hasErrorPassword: false,
      badCredentials: false,
      badPermission: false,
      disablePermission: false,
      NetworkError: false,
    };
  },
  async mounted() {},
  methods: {
     ...mapActions(["authenticate","checkSession", "logOut", "checkMe"]),
    keymonitor: function(event) {
      if (event.keyCode == 13) {
        this.login();
      }
      if (this.loginUser === "") {
        this.hasErrorUsername = true;
      } else {
        this.hasErrorUsername = false;
      }

      if (this.loginPass === "") {
        this.hasErrorPassword = true;
      } else {
        this.hasErrorPassword = false;
      }
    },
    async login() {
      if (this.loginUser != "" && this.loginPass != "") {
        try {
          let data = {
          email: this.loginUser,
          password: this.loginPass
        }
        let response = await this.authenticate(data);
         if(response.status == 200){
              await this.checkMe()
              response = await this.checkSession();
              if(response.status == 200){
                 this.badPermission = false;
                 this.$router.push("/home")
              }

        }

          
        } catch (error) {
          console.log(error)
          this.badCredentials = true;
          this.loginUser = "";
          this.loginPass = "";
          if (!error.response) {
            this.NetworkError = true;
            this.badCredentials = false;
            await this.logOut()
            this.$router.push("/")
          }
          if (error.response .data.error_description != "") {
            if (error.response.data.error_description == "User account has expired") {
              this.badCredentials = false;
              this.disablePermission = true;
            }
          }
          await this.logOut()
          this.$router.push("/")
        }
      } else if (this.loginUser === "" && this.loginPass === "") {
        this.hasErrorUsername = true;
        this.hasErrorPassword = true;
      } else if (this.loginUser === "") {
        this.hasErrorUsername = true;
      } else if (this.loginPass === "") {
        this.hasErrorPassword = true;
      } else {
        this.hasErrorUsername = true;
        this.hasErrorPassword = true;
      }
    },
    saveSession: function() {
      this.keepSession = !this.keepSession;
    },
    badCredentialsStatus: function() {
      this.badCredentials = false;
      this.badPermission = false;
      this.disablePermission = false;
    },

  },
  computed: {
    ...mapGetters({
      "auth": "getAuthenticated"
    }),

  }
};
</script>

<style scoped>

/*//////////////////////////////////////////////////////////////////
[ FONT ]*/



/*//////////////////////////////////////////////////////////////////
[ RESTYLE TAG ]*/

* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

body,
html {
  height: 100%;
  font-family: Poppins-Regular, sans-serif;
}

/*---------------------------------------------*/
a {
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 1.7;
  color: #666666;
  margin: 0px;
  transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
}

a:focus {
  outline: none !important;
}

a:hover {
  text-decoration: none;
  color: #3c8dbc;
}

/*---------------------------------------------*/
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0px;
}

p {
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 1.7;
  color: #666666;
  margin: 0px;
}

ul,
li {
  margin: 0px;
  list-style-type: none;
}

/*---------------------------------------------*/
input {
  outline: none;
  border: none;
}

textarea {
  outline: none;
  border: none;
}

textarea:focus,
input:focus {
  border-color: transparent !important;
}

input:focus::-webkit-input-placeholder {
  color: transparent;
}
input:focus:-moz-placeholder {
  color: transparent;
}
input:focus::-moz-placeholder {
  color: transparent;
}
input:focus:-ms-input-placeholder {
  color: transparent;
}

textarea:focus::-webkit-input-placeholder {
  color: transparent;
}
textarea:focus:-moz-placeholder {
  color: transparent;
}
textarea:focus::-moz-placeholder {
  color: transparent;
}
textarea:focus:-ms-input-placeholder {
  color: transparent;
}

input::-webkit-input-placeholder {
  color: #999999;
}
input:-moz-placeholder {
  color: #999999;
}
input::-moz-placeholder {
  color: #999999;
}
input:-ms-input-placeholder {
  color: #999999;
}

textarea::-webkit-input-placeholder {
  color: #999999;
}
textarea:-moz-placeholder {
  color: #999999;
}
textarea::-moz-placeholder {
  color: #999999;
}
textarea:-ms-input-placeholder {
  color: #999999;
}

/*---------------------------------------------*/
button {
  outline: none !important;
  border: none;
  background: transparent;
}

button:hover {
  cursor: pointer;
}

iframe {
  border: none !important;
}

/*//////////////////////////////////////////////////////////////////
[ Utility ]*/
.txt1 {
  font-family: Poppins-Regular;
  font-size: 13px;
  line-height: 1.5;
  color: #999999;
}

.txt2 {
  font-family: Poppins-Regular;
  font-size: 13px;
  line-height: 1.5;
  color: #666666;
}

/*//////////////////////////////////////////////////////////////////
[ login ]*/

.limiter {
  max-width: 100% !important;
}

.container-login100 {
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: #4eaeff;
  background-image: url("../../static/Login-footer-bg@3x.png");
  background-position: bottom;
  background-size: 100%;
  background-repeat: no-repeat;
}

.container-password100 {
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 30px;
  background: #4eaeff;
  /*background-image: url('../img/fondoRecoveryPass-1@3x.png');*/
  background-position: bottom;
  background-size: 100%;
  background-repeat: no-repeat;
}

.wrap-login100 {
  width: 960px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 120px 90px 120px 90px;
}

.wrap-password100 {
  width: 500px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 50px 50px 50px 50px;
}

/*------------------------------------------------------------------
[  ]*/
.login100-pic {
  width: 365px;
}

.login100-pic img {
  max-width: 100%;
}

.logo {
  width: 100%;
  height: auto;
}

.logo img {
  width: 70%;
  height: auto;
  margin: 0 50px;
}

.logo2 {
  width: 100%;
  height: auto;
  padding: 0px 220px;
}

.logo2 img {
  width: 20%;
  height: auto;
  margin: 10% 30% 2% 40%;
}

/*------------------------------------------------------------------
[  ]*/
.login100-form {
  width: 350px;
}
.recuperar100-form {
  width: auto;
}

.login100-form-title {
  font-family: Poppins-Bold;
  font-size: 24px;
  color: #333333;
  line-height: 1.2;
  text-align: center;

  width: 100%;
  display: block;
  padding-bottom: 54px;
}

/*---------------------------------------------*/
.wrap-input100 {
  position: relative;
  width: 100%;
  z-index: 1;
  margin-bottom: 10px;
}

.input100 {
  font-family: Poppins-Medium;
  font-size: 15px;
  line-height: 1.5;
  color: #666666;

  display: block;
  width: 100%;
  background: #e6e6e6;
  height: 50px;
  border-radius: 25px;
  padding: 0 30px 0 68px;
}

/*------------------------------------------------------------------
[ Focus ]*/
.focus-input100 {
  display: block;
  position: absolute;
  border-radius: 25px;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 0px 0px;
  color: rgba(66, 152, 222, 0.8);
}

.input100:focus + .focus-input100 {
  -webkit-animation: anim-shadow 0.5s ease-in-out forwards;
  animation: anim-shadow 0.5s ease-in-out forwards;
}

@-webkit-keyframes anim-shadow {
  to {
    box-shadow: 0px 0px 70px 25px;
    opacity: 0;
  }
}

@keyframes anim-shadow {
  to {
    box-shadow: 0px 0px 70px 25px;
    opacity: 0;
  }
}

.symbol-input100 {
  font-size: 15px;

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  position: absolute;
  border-radius: 25px;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-left: 35px;
  pointer-events: none;
  color: #666666;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.symbol-input100Error {
  font-size: 15px;

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  position: absolute;
  border-radius: 25px;
  bottom: 0;
  left: 0;
  top: -12px;
  width: 100%;
  height: 100%;
  padding-left: 35px;
  pointer-events: none;
  color: #666666;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.input100:focus + .focus-input100 + .symbol-input100 + .symbol-input100Error {
  color: #002746;
  padding-left: 28px;
}

/*------------------------------------------------------------------
[ Button ]*/
.container-login100-form-btn {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 20px;
}

.login100-form-btn {
  font-family: Montserrat-Bold;
  font-size: 15px;
  line-height: 1.5;
  color: #fff;
  text-transform: uppercase;

  width: 100%;
  height: 50px;
  border-radius: 25px;
  background: #2b9bfb;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 25px;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.login100-form-btn:hover {
  background: #333333;
}

/*------------------------------------------------------------------
[ Responsive ]*/

@media (max-width: 992px) {
  .wrap-login100 {
    padding: 177px 90px 33px 85px;
  }

  .wrap-password100 {
    /*padding: 80px 80px 80px 80px;*/
    padding: 177px 90px 33px 85px;
  }

  .login100-pic {
    width: 35%;
  }

  .login100-form {
    width: 50%;
    margin-top: -10%;
  }

  .recuperar100-form {
    width: 100%;
    margin-top: -10%;
  }
}

@media (max-width: 1440px) {
  .logo2 img {
    width: 50%;
    height: auto;
    margin: 10% 10% 2% 26%;
  }
}

@media (max-width: 1024px) {
  .logo2 img {
    width: 45%;
    height: auto;
    margin: 300px 135px 15px;
  }
}

@media (max-width: 768px) {
  .container-login100 {
    padding: 15px 128px;
  }
  .wrap-login100 {
    padding: 100px 80px 33px 80px;
  }

  .wrap-password100 {
    /*padding: 60px 60px 60px 60px;*/
    padding: 80px 80px 33px 80px;
  }

  .login100-pic {
    display: none;
  }

  .login100-form {
    width: 350px;
  }
  .recuperar100-form {
    width: 350px;
  }

  .logo2 img {
    width: 80%;
    height: auto;
    margin: 300px 30px 20px;
  }

  .logo img {
    width: 90%;
    height: auto;
    margin: 0px 15px;
  }
}
@media (max-width: 425px) {
  .container-login100 {
    padding: 15px 30px;
  }
}

@media (max-width: 576px) {
  .wrap-login100 {
    padding: 100px 15px 33px 15px;
  }
  .wrap-password100 {
    /*padding: 40px 40px 40px 40px*/
    padding: 60px 15px 33px 15px;
  }
  .logo img {
    width: 90%;
    height: auto;
    margin: 0px 15px;
  }

  .logo2 img {
    width: 150px;
    height: auto;
    margin: 400px -72px -10px;
  }
}

/*------------------------------------------------------------------
[ Alert validate ]*/

.validate-input {
  position: relative;
}

.alert-validate::before {
  content: attr(data-validate);
  position: absolute;
  max-width: 70%;
  background-color: white;
  border: 1px solid #c80000;
  border-radius: 13px;
  padding: 4px 25px 4px 10px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 8px;
  pointer-events: none;

  font-family: Poppins-Medium;
  color: #c80000;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;

  visibility: hidden;
  opacity: 0;

  -webkit-transition: opacity 0.4s;
  -o-transition: opacity 0.4s;
  -moz-transition: opacity 0.4s;
  transition: opacity 0.4s;
}

.alert-validate::after {
  content: "\f06a";
  font-family: FontAwesome;
  display: block;
  position: absolute;
  color: #c80000;
  font-size: 15px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 13px;
}

.alert-validate:hover:before {
  visibility: visible;
  opacity: 1;
}

@media (max-width: 992px) {
  .alert-validate::before {
    visibility: visible;
    opacity: 1;
  }
}
</style>